import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/projects',
    //   name: 'projects',
    //   component: () => import('./views/Projects.vue')
    // },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
